export const GOOGLE_MAP_API_KEY = "AIzaSyDL1Xs264nIq1NoVhqtdBThrBa9da3f52k";
